import { useCallback } from 'react';

import Tooltip from '@mui/material/Tooltip';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GridActionsCellItem } from '@mui/x-data-grid';

import type { FileItem } from './types/file-item.type';

interface ViewActionProps {
  readonly file: FileItem;
  readonly onView: (file: FileItem) => void;
}

export const ViewAction = ({ file, onView }: Readonly<ViewActionProps>) => {
  const handleClick = useCallback(() => {
    onView(file);
  }, [file, onView]);

  const actionLabel = 'Consulter';

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={actionLabel}>
          <VisibilityIcon fontSize="inherit" />
        </Tooltip>
      }
      label={actionLabel}
      onClick={handleClick}
    />
  );
};
